<template>
  <div class="min-h-screen flex flex-col">
    <NavBar />
    <Terminal class="ml-2 mr-2"/>
    <LearnMore class="flex justify-center items-center"/>
    <ExperienceEducation/>
    <ProjectsSection/>
    <Analytics />
  </div>
</template>

<script>

import NavBar from './components/NavBar.vue';
import Terminal from './components/Terminal.vue';
import ExperienceEducation from './components/ExperienceEducation.vue';
import ProjectsSection from './components/ProjectsSection.vue';
import LearnMore from './components/LearnMore.vue';
import { Analytics } from "@vercel/analytics/vue"

export default {
  name: 'App',
  components: {
    NavBar,
    Terminal,
    ExperienceEducation,
    ProjectsSection,
    LearnMore,
    Analytics
  }
};
</script>

<style scoped>

.content-container {
  margin-top: 1rem; 
  padding-bottom: 2rem; 
}

:global(body) {
  background-color: black;
}

</style>
